/**
 * Consultas por día (el día de su PRIMER mensaje), apiladas en cuatro series. Las dos de abajo
 * (respondidas y sin respuesta a tiempo) son la base de «Respondidas a tiempo»; arriba, las que se
 * cerraron sin responder y las que todavía esperan. Una sola escala: todas cuentan consultas.
 */

import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { FilaDiaConsultas } from "../../types.estadisticas";
import type { FilaGraficoConsultas } from "../../logic/estadisticas";
import { COLORES, COLOR_CONSULTA, TEXTO_SIN_CONSULTAS, serieConsultasGrafico } from "../../logic/estadisticas";
import { ESTILO_TOOLTIP, Leyenda, Vacio } from "./comun";

/** En el orden del apilado (el de la validación de la paleta). */
const SERIES: { clave: keyof Omit<FilaGraficoConsultas, "fecha" | "etiqueta">; label: string; color: string }[] = [
  { clave: "respondidas", label: "Respondidas", color: COLOR_CONSULTA.respondidas },
  { clave: "sinRespuesta", label: "Sin respuesta a tiempo", color: COLOR_CONSULTA.sinRespuesta },
  { clave: "cerradas", label: "Cerradas sin responder", color: COLOR_CONSULTA.cerradas },
  { clave: "esperando", label: "Esperando", color: COLOR_CONSULTA.esperando },
];

export function GraficoConsultas({ serie, alto = 220 }: { serie: FilaDiaConsultas[] | null | undefined; alto?: number }) {
  const datos = serieConsultasGrafico(serie);
  if (!datos.some((f) => SERIES.some((s) => f[s.clave] > 0))) return <Vacio>{TEXTO_SIN_CONSULTAS}</Vacio>;

  return (
    <div className="space-y-3">
      <Leyenda items={SERIES.map((s) => ({ color: s.color, label: s.label }))} />
      <div style={{ width: "100%", height: alto }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={datos} margin={{ top: 8, right: 8, bottom: 0, left: -12 }}>
            <CartesianGrid stroke={COLORES.grilla} vertical={false} />
            <XAxis dataKey="etiqueta" tick={{ fontSize: 11, fill: COLORES.eje }} tickLine={false} axisLine={false} minTickGap={16} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: COLORES.eje }} tickLine={false} axisLine={false} width={48} />
            <Tooltip {...ESTILO_TOOLTIP} formatter={(v, n) => [Number(v).toLocaleString("es-AR"), String(n)]} />
            {SERIES.map((s, i) => (
              <Bar key={s.clave} dataKey={s.clave} name={s.label} stackId="consultas" fill={s.color} stroke="#fff" strokeWidth={1}
                radius={i === SERIES.length - 1 ? [4, 4, 0, 0] : 0} isAnimationActive={false} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default GraficoConsultas;
